import { render, staticRenderFns } from "./BedRadarManagement.vue?vue&type=template&id=657abb42&scoped=true"
import script from "./BedRadarManagement.vue?vue&type=script&lang=js"
export * from "./BedRadarManagement.vue?vue&type=script&lang=js"
import style0 from "./BedRadarManagement.vue?vue&type=style&index=0&id=657abb42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657abb42",
  null
  
)

export default component.exports